import click_sound from './click.mp3';
import bell_sound from './bell.mp3';

const CLICK_SOUND = new Audio(click_sound);
const BELL_SOUND = new Audio(bell_sound);

export {
  CLICK_SOUND,
  BELL_SOUND,
};
